module.exports = __webpack_public_path__ + "static/ProximaNova-Extrabld-b0950a7a1a748b8a7d9974ebcb7baa2a.ttf";